import React from 'react';

export const NotFound = () => <div>Site you are looking for is not found</div>;
